import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBBtn,
  MDBIcon,
  MDBTypography
} from 'mdb-react-ui-kit';
import './Range.css';

interface RangeProps {
  theme: 'light' | 'dark';
}

const Range: React.FC<RangeProps> = ({ theme }) => {
  const navigate = useNavigate();

  const handleAddSessionManually = () => {
    navigate('/manual-entry');
  };

  return (
    <MDBContainer className="py-4">
      <MDBTypography tag="h1" className="text-center mb-4">
        <MDBIcon fas icon="bullseye" className="me-2" />
        Range
      </MDBTypography>

      {/* Control Buttons */}
      <div className="d-flex justify-content-center mb-4">
        <MDBBtn color="primary" size="lg" onClick={handleAddSessionManually}>
          <MDBIcon fas icon="camera" className="me-2" />
          Add Session Manually
        </MDBBtn>
      </div>

      <MDBCard>
        <MDBCardBody className="text-center py-5">
          <MDBIcon fas icon="bullseye" size="4x" className="text-primary mb-4" />
          <MDBTypography tag="h4" className="mb-3">Welcome to SolidRange</MDBTypography>
          <MDBTypography className="text-muted">
            Click "Add Session Manually" to upload a target image and record your shooting session.
          </MDBTypography>
        </MDBCardBody>
      </MDBCard>
    </MDBContainer>
  );
};

export default Range;
